import {
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableBody,
} from '@mui/material';
import React from 'react';

const TableComponent = ({
    columns,
    rows,
    count,
    rowsPerPage,
    page,
    setFilter,
    paginationOff,
}) => {
    const handleChangePage = (e, newPage) => {
        setFilter((prevFilter) => ({ ...prevFilter, page: newPage + 1 }));
    };

    const handleChangeRowsPerPage = (event) => {
        setFilter((prevFilter) => ({
            ...prevFilter,
            pageSize: +event.target.value,
            page: 1,
        }));
    };

    return (
        <div>
            {rows?.length > 0 && (
                <Paper style={{ width: '100%' }}>
                    <TableContainer style={{ maxHeight: '600' }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.key}
                                            align={column.align}
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '1rem',
                                                backgroundColor: 'lightgrey',
                                            }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, rowIndex) => {
                                    return (
                                        <TableRow
                                            key={`tabe-row-${row}-${rowIndex}`}
                                        >
                                            {columns.map((column, colIndex) => {
                                                return (
                                                    <TableCell
                                                        key={`tabe-row-${row}-${rowIndex}-col-${colIndex}`}
                                                        align={column.align}
                                                    >
                                                        {row[column.key]}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {count > rowsPerPage && !paginationOff && (
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage} // Use onChangePage instead of onPageChange
                            onRowsPerPageChange={handleChangeRowsPerPage} // Use onChangeRowsPerPage instead of onRowsPerPageChange
                        />
                    )}
                </Paper>
            )}{' '}
        </div>
    );
};

export default TableComponent;
